import React from 'react';
import { Box, Button, Typography, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { theme } from './theme';

const useStyles = makeStyles<Theme>((theme) => ({
  link: {
    marginTop: theme.spacing(2),
  },
}));

export const SubmittedEmail = () => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      alignContent="center"
    >
      <Typography
        align="center"
        variant="body1"
        style={{ maxWidth: theme.spacing(60), margin: 'auto' }}
      >
        Dziękujemy, wkrótce do Ciebie napiszemy. Między czasie dołącz do naszej
        grupy na facebooku. :)
      </Typography>
      <a
        className={classes.link}
        target="_blank"
        href="https://www.facebook.com/groups/677378655800732"
      >
        <Button size="large" variant="contained" color="primary">
          Dołącz do grupy
        </Button>
      </a>
    </Box>
  );
};

export default SubmittedEmail;
